module.exports = __webpack_public_path__ + "static/media/auto.b24af251.png";